import { useEffect, useState, useCallback } from 'react';

/**
 * Reusable resend cooldown timer for OTP flows.
 * Prevents spam-clicking resend buttons.
 *
 * @param initialSeconds - cooldown duration in seconds (default 30)
 */
export function useResendTimer(initialSeconds = 30) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (seconds <= 0) return;
    const id = setInterval(() => {
      setSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(id);
  }, [seconds]);

  const start = useCallback(() => {
    setSeconds(initialSeconds);
  }, [initialSeconds]);

  const reset = useCallback(() => {
    setSeconds(0);
  }, []);

  return {
    seconds,
    isActive: seconds > 0,
    start,
    reset,
  };
}
